import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Background Job
export function getViewManageBackgroundJobs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-background-jobs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageBackgroundJobLogs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-background-job-logs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathBackgroundJobs(jobId=null) {
  if (jobId) {
      return `background-jobs/${jobId}`;
  } else {
      return `background-jobs`;
  }
}

export function deleteBackgroundJobs(successCallback, errorCallback, jobId) {
  deleteAuth({
    "path": pathBackgroundJobs(jobId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Export Job
export function getViewManageExportJobs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-export-jobs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathExportJobs(jobId=null) {
  if (jobId) {
      return `export-jobs/${jobId}`;
  } else {
      return `export-jobs`;
  }
}

export function deleteExportJobs(successCallback, errorCallback, jobId) {
  deleteAuth({
    "path": pathExportJobs(jobId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function postExportJobResults(successCallback, errorCallback, jobId, qs={}) {
  postAuth({
    "path": urlUtils.appendQueryString(`export-jobs/${jobId}/results`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Import Job
export function getViewManageImportJobs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-import-jobs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageImportJobLogs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-import-job-logs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewImportJobShforms(jobId=null) {
  if (jobId) {
      return `view/import-job-shforms/${jobId}`;
  } else {
      return `view/import-job-shforms`;
  }
}

export function getViewImportJobShforms(successCallback, errorCallback, jobId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewImportJobShforms(jobId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathImportJobs(jobId=null) {
  if (jobId) {
      return `import-jobs/${jobId}`;
  } else {
      return `import-jobs`;
  }
}

export function createImportJobs(successCallback, errorCallback, data) {
  postAuth({
    "path": pathImportJobs(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteImportJobs(successCallback, errorCallback, jobId) {
  deleteAuth({
    "path": pathImportJobs(jobId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function urlImportJobUploadCsv() {
  return `/${constants.API_VERSION}/import-jobs/upload-csv`;
}

